// packages/web/src/components/marketplace/index.ts
// Public API exports for marketplace components

export { MarketplaceContainer } from './MarketplaceContainer';
export { ServiceGrid } from './ServiceGrid';
export { SearchFilters } from './SearchFilters';
export { CatalogSelector } from './CatalogSelector';

// Re-export existing components for backward compatibility
export { default as ShoppingCart } from './ShoppingCart';
export { ServiceCardNew as ServiceCard } from './ServiceCardNew';
export { AddToCartButton } from './AddToCartButton';
export { BrandRevealPrompt } from './BrandRevealPrompt';

// Term display components
export { TermChips } from './TermChips';
export { TermTabs } from './TermTabs';